module.exports = __webpack_public_path__ + "img/loading.4859da72.gif";